import React from "react";
import Slider from "react-slick";

export default function HomeClient() {

  const settingslogo = {
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: "linear",
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,

    responsive: [

      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 601,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }


  const settingstestimonial = {
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    // cssEase: "ease",
    autoplaySpeed: 7000,
    speed: 4000,
    infinite: true,
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide"><i className="fa-solid fa-arrow-left"></i> </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide"  > <i className="fa-solid fa-arrow-right"></i></button>
    ),
    arrows: true,
    dots: false,
    pauseOnHover: false,
    adaptiveHeight: true,
  }

  const testimonials = [
    {
      authorImg: "/assets/images/home-author-image1.webp",
      name: "Mr. Piyush Goyal",
      designation: "Managing Director (Kelley MHE India Private Limited)",
      quoteImg: "/assets/images/quote-img.webp",
      title: "AWL India has become a key partner for us.",
      paras: [
        "Words are less to describe the achievements of the entire AWL India team. So many years of warehousing partnership and never single chance of complaint. The entire management and team is highly dedicated and aims to retain clients with them for years, how? Best unhindered and no questions asked service.",
        "Words are less to describe the achievements of the entire AWL India team. So many years of warehousing partnership and never single chance of complaint. The entire management and team is highly dedicated and aims to retain clients with them for years, how? Best unhindered and no questions asked service."
      ]
    },

    {
      authorImg: "/assets/images/home-author-image4.webp",
      name: "Mr. Dinesh Kumar",
      designation: "Supply Chain Head - Keventers, Kolkata",
      quoteImg: "/assets/images/quote-img.webp",
      title: "Exceptional Services",
      paras: [
        "I am delighted to express my heartfelt appreciation for the exceptional services rendered by AWL India at the Kolkata warehouse facility during the past two years. Managing warehouse operations is a challenging task, filled with ups and downs, yet your team's unwavering cooperation has enabled us to streamline our operations successfully. I extend my sincere gratitude to your team for their hard work, dedication, and remarkable efforts in managing our operations. We eagerly anticipate maintaining the same level of enthusiasm, dedication, and spirit in our future endeavours. Together, let us continue excelling in every facet of our business and foster a robust team.",
      ]
    },


    {
      authorImg: "/assets/images/home-author-image6.webp",
      name: "Mr. Amol Prasadi",
      designation: "Associate General Manager (Kaya Limited)",
      quoteImg: "/assets/images/quote-img.webp",
      title: "Delay - Not in their Dictionary",
      paras: [
        "Meeting deadlines is what defines success of our business. Many of our orders are bound by strict deadlines. AWL India's team delivers the order on time with real time en-route updates. We highly enjoy and recommend their service.",

      ]
    },


    {
      authorImg: "/assets/images/home-author-image2.webp",
      name: "Mr. Suvendu Sahu",
      designation: "Chief Financial Officer (Quest Retail Private Limited)",
      quoteImg: "/assets/images/quote-img.webp",
      title: "Appreciate the Partnership",
      paras: [

        "Words are less to describe the achievements of the entire AWL India team. So many years of warehousing partnership and never single chance of complaint. The entire management and team is highly dedicated and aims to retain clients with them for years, how? Best unhindered and no questions asked service.",
      ]
    },


    {
      authorImg: "/assets/images/home-author-image5.webp",
      name: "Mr. Prashant Singh",
      designation: "Country Head (Callaway Golf India Private Limited)",
      quoteImg: "/assets/images/quote-img.webp",
      title: "Best Customer Service",
      paras: [
        "Bow down to the entire team of AWL India. Together they helped to push an emergency shipment as early as possible. They didn't call it quits after the first few attempts to find the closest possible truck went failed. By far the best customer service from a logistics company in a long time.",

      ]
    },
    {
      authorImg: "/assets/images/home-author-image3.webp",
      name: "Mr. Sanjay Jain",
      designation: "Chief Executive Officer (Elan Professional Appliances Private Limited)",
      quoteImg: "/assets/images/quote-img.webp",
      title: "Professional, Courteous and Willing to help",
      paras: [
        "Our entire team is indebted and values AWL India. Many times we have reached out to them for emergency shipments and they have never let us down. Every employee on their team is highly responsible, professional and courteous. Kudos to the amazing service, keep it up..!!",
      ]
    },
  ];

  const logos = [
    "/assets/images/Untitled-1.webp",
    // "/assets/images/Untitled-2.webp",
    "/assets/images/Untitled-3.webp",
    "/assets/images/Untitled-4.webp",
    "/assets/images/Untitled-5.webp",
    // "/assets/images/Untitled-2.webp",
    "/assets/images/Untitled-3.webp",
  ];

  // const [nav1, setNav1] = React.useState(null);
  // const [nav2, setNav2] = React.useState(null);

  // const slider1 = React.useRef(null);
  // const slider2 = React.useRef(null);

  // React.useEffect(() => {
  //   setNav1(slider1.current);
  //   setNav2(slider2.current);
  // }, []);

  // const settingsMain = {
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   infinite: true,
  //   speed: 2000,
  //   arrows: false,
  //   dots: false,
  //   asNavFor: nav2,
  // };

  // const settingsThumbs = {
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   infinite: true,
  //   speed: 2000,
  //   asNavFor: nav1,
  //   arrows: false,
  //   dots: false,
  //   focusOnSelect: true,
  //   centerMode: true,
  //   responsive: [
  //     { breakpoint: 992, settings: { slidesToShow: 3 } },
  //     { breakpoint: 757, settings: { slidesToShow: 3 } },
  //     { breakpoint: 599, settings: { slidesToShow: 2 } }
  //   ]
  // };

  return (
    <section className="testimonial-section space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="heading-text">
              <h4 className="heading center-heading">What Our Clients Say</h4>
            </div>
          </div>
        </div>

        <div className="tabber-area">
          {/* Main Slider */}
          <Slider {...settingstestimonial} className="slider-content">
            {testimonials.map((testi, index) => (
              <div className="testomial-slider" key={index}>
                <div className="testimonial-detail">
                  <div className="testimonial-row">
                    <div className="testi-image">
                      <div className="testi-inner">
                        <img src={testi.authorImg} alt="author" loading="lazy" />
                        <div className="overlay-content">
                          <div className="heading">{testi.name}</div>
                          <p className="des">{testi.designation}</p>
                        </div>
                      </div>
                    </div>
                    <div className="testi-content">
                      <img src={testi.quoteImg} alt="quote" loading="lazy" className="quote-img" />
                      <div className="heading">{testi.title}</div>
                      {testi.paras.map((p, i) => <p key={i}>{p}</p>)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          {/* Thumbs Slider */}
          <Slider {...settingslogo} className="slider-thumb">
            {logos.map((logo, i) => (
              <div className="nav-links" key={i}>
                <div className="nav-links-wrap">
                  <img src={logo} alt="logo" loading="lazy" />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
